import { Mail, Phone, Linkedin, Github, Send } from 'lucide-react'
import { getContactInfo } from '../utils/cvParser'

const Contact = () => {
  const contact = getContactInfo()
  
  const linkedIn = contact.socialNetworks.find(n => n.network === 'LinkedIn')
  const github = contact.socialNetworks.find(n => n.network === 'GitHub')

  return (
    <section id="contact" className="bg-gradient-to-br from-navy-800 to-primary-900 text-white">
      <div className="section-container">
        <h2 className="section-title text-center text-white">Let's Work Together</h2>
        
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-xl text-gray-200 leading-relaxed">
            Looking for a data engineering consultant to help transform your data infrastructure? 
            I'm available for consulting projects and would love to discuss how I can help your business.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          <a 
            href={`mailto:${contact.email}`}
            className="card bg-white/10 backdrop-blur-sm border-2 border-white/20 hover:bg-white/20 hover:scale-105 transition-all duration-300"
          >
            <div className="flex items-center gap-4">
              <div className="bg-white/20 p-4 rounded-full">
                <Mail size={24} />
              </div>
              <div className="text-left">
                <h3 className="font-semibold text-lg mb-1">Email</h3>
                <p className="text-gray-200">{contact.email}</p>
              </div>
            </div>
          </a>

          {contact.phone && (
            <a 
              href={`tel:${contact.phone}`}
              className="card bg-white/10 backdrop-blur-sm border-2 border-white/20 hover:bg-white/20 hover:scale-105 transition-all duration-300"
            >
              <div className="flex items-center gap-4">
                <div className="bg-white/20 p-4 rounded-full">
                  <Phone size={24} />
                </div>
                <div className="text-left">
                  <h3 className="font-semibold text-lg mb-1">Phone</h3>
                <p className="text-gray-200">{contact.phone}</p>
                </div>
              </div>
            </a>
          )}

          {linkedIn && (
            <a 
              href={`https://linkedin.com/in/${linkedIn.username}`}
              target="_blank"
              rel="noopener noreferrer"
              className="card bg-white/10 backdrop-blur-sm border-2 border-white/20 hover:bg-white/20 hover:scale-105 transition-all duration-300"
            >
              <div className="flex items-center gap-4">
                <div className="bg-white/20 p-4 rounded-full">
                  <Linkedin size={24} />
                </div>
                <div className="text-left">
                  <h3 className="font-semibold text-lg mb-1">LinkedIn</h3>
                <p className="text-gray-200">Connect with me</p>
                </div>
              </div>
            </a>
          )}

          {github && (
            <a 
              href={`https://github.com/${github.username}`}
              target="_blank"
              rel="noopener noreferrer"
              className="card bg-white/10 backdrop-blur-sm border-2 border-white/20 hover:bg-white/20 hover:scale-105 transition-all duration-300"
            >
              <div className="flex items-center gap-4">
                <div className="bg-white/20 p-4 rounded-full">
                  <Github size={24} />
                </div>
                <div className="text-left">
                  <h3 className="font-semibold text-lg mb-1">GitHub</h3>
                <p className="text-gray-200">View my code</p>
                </div>
              </div>
            </a>
          )}
        </div>
      </div>
    </section>
  )
}

export default Contact
